export default __webpack_public_path__ + "static/c3-e9a96d3739780cfdf1b3e97543accf01.jpg";